import type { HelpFile } from '../../types/help'
import { LoadingStateTestIds } from '../../../testids/LoadingStateTestIds'

export const loadingStateHelp: HelpFile = {
  texts: {
    [LoadingStateTestIds.loadingState]: null,
    [LoadingStateTestIds.loadingMessage]: null,
  },
}
